<template>
    <div class="router-view-content">
        <h1>Klienci</h1>
        <h2>Wybierz produkty i wygeneruj listę klientów</h2>
        <div
            style="
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding: 0.5rem 0;
            "
        >
            <input placeholder="Szukaj" v-model="search" type="search" />
            <ActionButton label="Generuj" color="apple" @click="generate" />
        </div>
        <RegularList
            :selectList="true"
            :header="listHeader"
            :items="listItems"
            @itemSelected="itemSelected"
            @updated="listUpdated"
        />
        <transition name="fade">
            <SupportBillCreator
                :selectedItem="selectedItem"
                v-if="selectedItem.uuid"
                @close="selectedItem = {}"
            />
        </transition>
    </div>
</template>
<script>
export default {
    components: {
        SupportBillCreator: () => import('./SupportBillCreator')
    },
    data() {
        return {
            listHeader: [
                {
                    display: 'Tytuł',
                    size: 2
                },
                {
                    display: 'Koszt',
                    size: 2
                },
                {
                    display: 'Odbiorcy',
                    size: 2
                },
                {
                    display: 'Typ',
                    size: 2
                }
            ],
            productsList: [],
            selectedProducts: [],
            search: '',
            loading: false,
            selectedItem: {}
        }
    },
    computed: {
        listItems() {
            const local = this.$store.getters['content/allProducts']
            return local
                .filter(w => {
                    const r = new RegExp(`\\w?${this.search}\\w?`, 'i')
                    return r.test(w.title)
                })
                .map(webinar => {
                    return {
                        key: webinar.uuid,
                        payload: webinar,
                        cells: [
                            {
                                type: 'text',
                                display: webinar.title,
                                size: 2
                            },
                            {
                                type: 'text',
                                display: webinar.cost,
                                size: 2
                            },
                            {
                                type: 'text',
                                display: webinar.types,
                                size: 2
                            },
                            {
                                type: 'text',
                                display: webinar.webinars
                                    ? 'Konferencja'
                                    : 'Webinar',
                                size: 2
                            }
                        ]
                    }
                })
        }
    },
    methods: {
        itemSelected(item) {
            this.selectedItem = item
        },
        generate() {
            if (this.loading) {
                return
            }
            this.loading = true
            const uuid = this.selectedProducts.join(', ')
            this.$api
                .get(`v1/marketplace/dump-csv?uuid=(${uuid})`)
                .then(({ data }) => {
                    const csv = 'data:text/csv;charset=utf-8,' + data
                    var encodedUri = encodeURI(csv)
                    window.open(encodedUri)
                })
                .catch(error => this.$Network.handleError(error))
                .then(() => (this.loading = false))
        },
        listUpdated(items) {
            this.selectedProducts = items.map(i => `"${i.uuid}"`)
        }
    }
}
</script>
